<style scoped lang="scss">
  .lh40 {
    line-height: 40px;
    color: white;
  }

  .loading-container {

    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    text-align: center;

    .loading-backdrop {
      position: fixed;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background-color: lightgray;
      opacity: 0.5;
      z-index: 9998;
    }

    .loading {
      z-index: 9999;
      position: fixed;
      display: inline-block;
      background-color: #051f3a;
      padding: 20px 50px;
      border-radius: 12px;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
      left: 50%;
      top: 50%;
      -ms-transform: translate(-50%, -50%);
      -moz-transform: translate(-50%, -50%);
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);

      .loading-icon {
        margin-bottom: 8px;
      }
    }
  }
</style>

<template>
  <div class="loading-container" v-show="blocker.block">
    <div class="loading-backdrop"></div>
    <div class="loading">
      <div class="loading-icon">
        <b-row>
          <b-col v-if="blocker.displayLoader"
                 :sm="12" :md="6" :lg="6"
          >
            <b-img
              src="./static/base/new_logo_loading.png"
              title="Please wait, loading..."
              alt="Loading the content."
            >
            </b-img>
          </b-col>
          <b-col :sm="12"
                 :md="blocker.displayLoader ? 6: 12"
                 :lg="blocker.displayLoader ? 6 : 12" class="lh40">
            {{ blocker.message }}
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    blocker() {
      return this.$store.getters.blockUIData;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/UiBlocker.vue